import { Button, Card } from 'antd'
import { useApiContext } from "../../hooks/useApiContext";
import { CloseOutlined} from "@ant-design/icons";
import { DemandIems } from "../../services/items";
import React from 'react'
import logo from '../../assets/logo.png'
import './styles.css'



const DemandTemplate= React.forwardRef((props, ref) =>{

        const {demandletteritems, demandLetterItemdispatch} = useApiContext()
        const deleteItem = (id) => {
            const getitems = demandletteritems.filter((x) => x.id !== id);
            DemandIems.delete(demandLetterItemdispatch, getitems);
            console.log("Id", demandletteritems);
          };
          return (
    <Card  title="Demand Contract template" bordered className='container'>
        <div ref={ref}>
        {/* <img src={logo} className="plogo"/> */}
        <h2 className='t-center m-0'>{props.arabicTitle}</h2>
        <h2 className='t-center m-0'>{props.englishTitle}</h2>
        <table style={{margin:'20px 10px', width:'100%'}}>
        <td style={{width:'50%'}}>
            <p>Issue Date: <b>{props.issueDate}</b></p> <br />
            <p>
            <b>1. Name of Manpower Agency: {props.agencyName}</b> <br />
            <b>2. Address: {props.addressEnglish}</b> <br />
            <b>3. License No: {props.licenseNo}</b>
            </p>
           
        </td>
        <td dir='rtl' style={{width:'50%'}}>
            <p style={{paddingRight:'10px'}}>التاريخ: <b>{props.issueDate}</b></p> <br />
            <p>
                <b>اسم الوكالة في نيبال : {props.agencyNameArabic}</b> <br />
                <b>العنوان :{props.addressArabic}</b> <br />
                <b>رقم الترخيص :{props.licenseNo}</b>

            </p>
        </td>
        </table>
        <table className='table table-bordered'>
            <thead>
                <th>SN</th>
                <th>Profession</th>
                <th>Occupation</th>
                <th>Male</th>
                <th>Female</th>
                <th>Total</th>
                <th>Salary</th>
                <th>Daily Working Hours</th>
            </thead>
            <tbody>
               {demandletteritems && 
               demandletteritems.map((item, i)=>(
                  <tr key={item.id}>
                      <td>{i == 0 ? 1 : i + 1}</td>
                      <td>{item.profession}</td>
                      <td>{item.occupation}</td>
                      <td>{item.male}</td>
                      <td>{item.female}</td>
                      <td>{item.itemtotal}</td>
                      <td>{item.salary}</td>
                      <td>{item.itemdailyHours} 
                      <Button
                      style={{ marginLeft: "10px" }}
                      onClick={() => deleteItem(item.id)}
                      danger
                      icon={<CloseOutlined />}
                      size="small"
                      shape="circle"
                    />
                      </td>
                    
                  </tr>

               ))}
            </tbody>
        </table>
        
        <table style={{marginTop:'20px'}} >
            <thead>
                <th colSpan={2}>
                The following Terms & conditions shall be included in the contract <br />
                يجب تضمين الشروط والأحكام التالية في العقد المبرم بين الطرفين
                </th>
            </thead>
            <td style={{width:'50%', border:'1px solid gray'}}>
       <ul>
    <li>Period of Employment: Two years(renewable) </li> 
    <li>Place of employment: (Anywhere in Saudi Arabia) KSA.</li>    
    <li>{props.workingDaysPerWeek} days a week ({props.workingHoursPerDay} hrs. {props.workingDaysPerMonth} days a month.)</li> 
    <li>Over time: as per Saudi Labor Law</li>
    <li>Probation Period: 90 days from date of entry into KSA</li>
    <li>Resident Permit:  Resident Permit will be provided by the company free of cost </li>
    <li>Medical Insurance : Provided by the company</li>
    <li>Insurance from GOSI (In case of on-duty casualties) : Provided </li>
    <li>Accommodation,Water, Electricity & Gas : Provided by the company free of cost. </li>
    <li>Transportation:
        <ul>
            <li>Transportation (Bus): Provided by the company 
(to and from the work site) </li>
<li>Transportation vehicle : Provided by company</li>
        </ul>
    </li>
    <li>Uniform, and Safety Materials : Provided by the company</li>
    <li>Annual paid Leave : minimum 21 days  per year </li>
    <li>Attention bonus (for monthly SR100)</li>
    <li>Other Terms & Conditions : as per Saudi Labor Law</li>
    <li>Without proper region askance the job company will be dedicated 1days salary.</li>
    <li>When Arrival in Saudi Arabia after 15 days without job only Staying company Accommodation. company will provide only food Allowance because 15 days prepared for medical, insurance work permits Etc.</li>
    <li>When workers Join the Work after 2 months will get first salary. then Continue each of month.</li>
     <i> <b>Note</b> </i>: We are Project around in Saudi Arabia and Same Categories Job, not Fixed any Job without Construction, Categories is ({props.services}) of Public Place etc. our Project as Hotel, Market, Petrol pump, Factories, Army Catering Event Etc. Project in Saudi Arabia. visit www.bestgroupltd.com
     <li>All other Facilities as a Saudi Arabia Labor Laws.</li>
        </ul>         
            </td>
            <td style={{width:'50%', border:'1px solid gray'}}>
                <ul dir='rtl'>
                    <li>مدة التوظيف: سنتان (قابلة للتجديد)</li>
                    <li>مكان العمل: (في أي مكان بالمملكة العربية السعودية) المملكة العربية السعودية</li>
                    <li>{props.workingDaysPerWeek} أيام في الأسبوع ({props.workingHoursPerDay} ساعات. {props.workingDaysPerMonth} يومًا في الشهر.)</li>
                    <li>الزمن الإضافي : يحتسب بواقع 5. 1على الأقل من ساعات العمل من الراتب الأساسي</li>
                    <li>الفترة التجريبية: مدتها تسعون يوما تبدأ من تاريخ دخول العامل أراضي المملكة العربية السعودية   </li>
                    <li> تُستخرج للعامل رخصة الاقامة من قبل الشركة دون أي رسوم عليه  </li>
                    <li> تؤمن الشركة للعامل تأمين طبي مجاني</li>
                    <li> يلزم اشتراك العامل في التأمينات الاجتماعية، ليستفيد من التعويض في حالتي الإصابة في العمل والوفاة. </li>
                    <li>يُمنح العامل السكن، وخدمات الماء والكهرباء والغاز من قبل الشركة</li>
                    <li>التنقل: 
                        <ul>
                            <li> توصل الشركة العامل بالحافلة او غيرها من وسائل النقل من وإلي موقع العمل</li>
                            <li>تؤمن  الشركة سيارات خاصة  للموظفين  </li>
                        </ul>
                    </li>
                    <li>الزي، وأدوات السلامة: تمنح الشركة العامل الزي الذي يتلائم مع  طبيعة العمل وكذلك أدوات السلامة</li>
                    <li>الإجازة السنوية: 21 يوماعلي الأقل</li>
                    <li>ان تمنح الشركة علاوة بدل رحلة لسائقي الشاحنات الثقيلة</li>
                    <li>الشروط والأحكام الأخري التي لم تُذكر: تكون وفقا على  ما منصوص عليه في قانون العمل السعودي</li>
                    <li> بدون طلب المنطقة المناسبة ، سيتم تخصيص راتب يوم واحد لشركة العمل</li>
                    <li>عند الوصول إلى المملكة العربية السعودية بعد 15 يومًا بدون عمل الإقامة فقط في سكن الشركة. ستقدم الشركة بدل طعام فقط لأن 15 يومًا معدة للحصول على تصاريح العمل الطبية والتأمين وما إلى ذلك.</li>
                    <li>N / B: عندما يلتحق العمال بالعمل بعد شهرين سيحصلون على الراتب الأول. ثم تابع كل شهر.
  نحن مشروع في المملكة العربية السعودية ونعمل في نفس الفئات ، ولم يتم إصلاح أي وظيفة بدون إنشاء ، الفئات هي ({props.services}) للأماكن العامة وما إلى ذلك. مشروعنا مثل فندق ، سوق ، مضخة بنزين ، مصانع ، حدث تموين الجيش ، إلخ مشروع في السعودية. قم بزيارة www.bestgroupltd.com
</li>
            <li>جميع المنشآت الأخرى مثل قوانين العمل السعودية</li>
                </ul>
            </td>
        </table>
        <table style={{marginTop:'30px', width:'100%'}}>
            {props.conditionItems.map(item =>(
                <>
                    <thead>
                <th colSpan={2}>
                {item.headingEnglish} <br />
                {item.headingArabic}
                </th>
            </thead>
            <tbody>
                <td style={{width:'50%', border:'1px solid gray', padding:'10px'}}>
                    {item.conditionEnglish}
                </td>
                <td dir='rtl' style={{width:'50%', border:'1px solid gray', padding:'10px'}}>
                    {item.conditionArabic}
                </td>
            </tbody>
                </>
            ))}
        
        </table>
             
        </div>
</Card>
  
 ) })

export default DemandTemplate; 
